// Phone-only bar pinned to the bottom of the screen while the page's main action button is scrolled away.
export const MobileStickyBar = ({ show, testId, label, value, action, onAction, disabled }) => (
  <div
    data-testid={testId}
    aria-hidden={!show}
    className={`md:hidden fixed inset-x-0 bottom-0 z-40 bg-white/95 backdrop-blur-md border-t border-[#F0EBE1] px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] flex items-center gap-3 shadow-[0_-8px_24px_rgba(28,25,23,0.08)] transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full pointer-events-none"}`}
  >
    <div className="min-w-0 flex-1 leading-tight">
      <p className="text-xs text-stone-500 truncate">{label}</p>
      <p className="font-heading text-lg font-bold">{value}</p>
    </div>
    <button
      data-testid={`${testId}-button`}
      onClick={onAction}
      disabled={disabled}
      tabIndex={show ? 0 : -1}
      className="shrink-0 bg-[#E06D44] text-white h-12 px-6 rounded-full font-semibold active:scale-95 disabled:opacity-60 transition-[background-color,transform] hover:bg-[#C95B33]"
    >
      {action}
    </button>
  </div>
);
